import request from '@/utils/request'

const BASE_URL = '/news'

//新闻列表
export function newsList(data) {
  return request({
    url: `${BASE_URL}/list`,
    method: 'post',
    data
  })
}

//新闻详情
export function newsDetail(id) {
  return request({
    url: `${BASE_URL}/detail?id=${id}`,
    method: 'post'
  })
}
